import { InputGroup } from '@blueprintjs/core'
import { handleStringChange } from '@blueprintjs/docs-theme'

import * as classnames from 'classnames/bind'
import * as firebase from 'firebase'
import * as moment from 'moment'
import * as React from 'react'

import { dispatch } from '../../store'
import styles from './lecture-date-setting.scss'
import itemStyles from './lecture-item.scss'
const cx = classnames.bind({ ...styles, ...itemStyles })

interface IProps {
  isEdit: boolean,
  lectureId: string,
  lecture: ILecture
}

interface IState {
  isEnabled?: boolean,
  estimatedDuration: number,
  prepareDay: number,
  listPrice: number,
  earlyPrice: number,
  startedAt: string
}

class LectureDateSetting extends React.Component<IProps, IState> {
  public state: IState = {
    isEnabled: false,
    estimatedDuration: 0,
    prepareDay: 0,
    listPrice: 0,
    earlyPrice: 0,
    startedAt: '-'
  }

  public handleEstimatedDurationChange = handleStringChange((estimatedDuration:string) => {
    const { lectureId } = this.props
    this.setState({ estimatedDuration: parseInt(estimatedDuration, 10) })
    dispatch.lectures.updateLecture({
      lectureId, updated: { estimatedDuration: parseInt(estimatedDuration, 10) }
    })
  })

  public handleprepareDayChange = handleStringChange((prepareDay:string) => {
    const { lectureId } = this.props
    const prepareDayNum = parseInt(prepareDay, 10)
    const soldTime = moment()
    const startedTime = moment().add(prepareDayNum, 'days')
    const endTime = moment().add(prepareDayNum + 30, 'days')
    this.setState({ prepareDay: prepareDayNum })

    dispatch.lectures.updateLecture({
      lectureId, updated: {
        soldAt: firebase.firestore.Timestamp.fromDate(soldTime.toDate()),
        startedAt: firebase.firestore.Timestamp.fromDate(startedTime.toDate()),
        endedAt: firebase.firestore.Timestamp.fromDate(endTime.toDate()),
      }
    })
  })

  public handlePriceChange = handleStringChange((listPrice:string) => {
    const { lectureId } = this.props
    this.setState({ listPrice: parseInt(listPrice, 10) })
    dispatch.lectures.updateLecture({
      lectureId, updated: { listPrice: parseInt(listPrice, 10) }
    })
  })

  public handleEarlyPriceChange = handleStringChange((earlyPrice:string) => {
    const { lectureId } = this.props
    this.setState({ earlyPrice: parseInt(earlyPrice, 10) })
    dispatch.lectures.updateLecture({
      lectureId, updated: { earlyPrice: parseInt(earlyPrice, 10) }
    })
  })

  public componentWillReceiveProps = (nextProps:IProps) => {
    const { estimatedDuration, listPrice, earlyPrice } = nextProps.lecture
    const startedAt = moment.unix(nextProps.lecture.startedAt.seconds).format('YYYY/MM/DD')
    const prepareDay = Math.ceil(moment.duration(moment.unix(nextProps.lecture.startedAt.seconds).diff(moment())).asDays())
    // Math.ceil(moment.duration(moment.unix(nextProps.lecture.startedAt.seconds).diff(moment())).asDays()) )
    this.setState({ estimatedDuration, listPrice, earlyPrice, startedAt, prepareDay })
  }
  public render() {
    const { estimatedDuration, prepareDay, listPrice, earlyPrice, startedAt } = this.state
    return (
      <div className={cx('lecture_section')}>
        <h4><span>*</span>講座預購期為30天，可準備的天數為3-30天</h4>
        <h4><span>*</span>講座開賣至開講30天內 / 分潤比例為講師7 平台3；開講30天後 / 分潤比例為講師3 平台7</h4>

        <div className={cx('date-setting-section')}>
          <div className={cx('date-setting-formGroup')}>
            <div className={cx('date-input-field')}>

              <h4>預估討論觀點</h4>
              <InputGroup
                large={true}
                className={cx('date-input')}
                onChange={this.handleEstimatedDurationChange}
                placeholder=""
                type="number"
                min={0}
                value={estimatedDuration.toString()}
                rightElement={<p>分鐘</p>}
              />
            </div>

            <div className={cx('date-input-field')}>
              <h4>預估準備天數</h4>
              <InputGroup
                large={true}
                className={cx('date-input')}
                onChange={this.handleprepareDayChange}
                placeholder=""
                type="number"
                min={0}
                value={prepareDay.toString()}
                rightElement={<p>天</p>}
              />
            </div>

            <div className={cx('date-input-field')}>
              <h4>預估售價</h4>
              <InputGroup
                large={true}
                className={cx('date-input')}
                onChange={this.handlePriceChange}
                placeholder=""
                type="number"
                min={0}
                value={listPrice.toString()}
                rightElement={<p>元</p>}
              />
            </div>

            <div className={cx('date-input-field')}>
              <h4>預估早鳥價</h4>
              <InputGroup
                large={true}
                className={cx('date-input')}
                onChange={this.handleEarlyPriceChange}
                placeholder=""
                type="number"
                min={0}
                value={earlyPrice.toString()}
                rightElement={<p>元</p>}
              />
            </div>

          </div>
          <div className={cx('date-preview')}>
            <h4>預計於</h4>
            <h4>{startedAt} 開講</h4>
          </div>
        </div>
      </div>
    )
  }
}

export default LectureDateSetting


// WEBPACK FOOTER //
// ./src/pages/LecturePage/lecture-date-setting.tsx